import React, { useEffect, useState } from 'react'
import IssueTopicOverview from '../IssueTopicOverview'
import '../../styles/IssuesGroup.css'
import IssueTopicItem from './IssueTopicItem'
import InfiniteScroll from 'react-infinite-scroll-component'
import useDebounce from '../../hooks/useDebounce'
import { Oval } from 'react-loader-spinner'
import { ReactComponent as LeftArrow } from '../../svg/normalSvgs/LeftArrow.svg'
import { ReactComponent as SearchIcon } from '../../svg/biggerIcons/SearchIcon.svg'
import { useParams, Link } from 'react-router-dom'
import { getIssues } from '../../server/server'
import { useTranslation } from 'react-i18next'
import i18n from '../../i18n'
import TaskMascot from '../../svg/UpstriveTaskMaskot'

export default function SolutionsGroup() {
    const { id: issueType } = useParams()
    const [searchText, setSearchText] = useState('')
    const [issuesTopics, setIssuesTopics] = useState([])
    const [issuesServerCount, setIssuesServerCount] = useState(0)
    const [loading, setLoading] = useState(false)
    const [selectedIssueTopic, setSelectedIssueTopic] = useState()
    const everythingLoaded = issuesTopics?.length === issuesServerCount
    const debouncedSearchText = useDebounce(searchText, 300)
    const { t } = useTranslation()
    const locale = i18n.language

    const _fetchIssues = async (loadedContent = 0, searchText = '') => {
        const response = await getIssues({
            issueType,
            loadedContent,
            searchText,
            local: locale,
        })
        if (loadedContent === 0) {
            try {
                setIssuesTopics(response?.data?.data)
                setIssuesServerCount(response?.data?.size)
                setSelectedIssueTopic(response?.data?.data[0])
            } catch (error) {}
        } else {
            setIssuesTopics((prevState) => [...prevState, ...response?.data.data])
        }

        setLoading(false)
    }

    useEffect(() => {
        setLoading(true)
        _fetchIssues(0, debouncedSearchText)
    }, [debouncedSearchText])

    const LoadingSpinner = () => {
        return (
            <div className="issue-group-loader">
                <Oval secondaryColor="#7ec5c6" color="#7ec5c6" height={80} width={80} />
            </div>
        )
    }
    const handleClick = (item) => {
        var myDiv = document.getElementById('solutions-group-scroll')
        myDiv?.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
        setSelectedIssueTopic(item)
    }

    return (
        <div className={`issue-group-container ${i18n.language == 'ar' ? 'ar-trans' : ''}`}>
            <div className="issue-group-main">
                <div className="issue-group-section shadow-custom-soft">
                    {/* TODO: Change icon */}
                    {/* <TaskMascot className="task-mascot-solutions" /> */}
                    <div className="issue-group-section-title">
                        <span className="issue-group-section-arrow mt-4">
                            <Link to="/solutions">
                                <LeftArrow className={i18n.language == 'ar' ? 'ar-transform' : ''} />
                            </Link>
                        </span>
                        <div className="solutions-title-text">{t('solutions')} </div>
                    </div>
                    <div className="issue-group-search">
                        <div className="issue-group-search-input-holder">
                            <input type="text" value={searchText} placeholder={t('search')} onChange={(e) => setSearchText(e.target.value)} />
                            <SearchIcon className={` ${i18n.language == 'ar' ? 'ar-transform' : ''}`} />
                        </div>
                    </div>
                    <div id="issue-group-issues-list" className="issue-group-list issue-group-list-overflow grey-small-scroll">
                        {loading && <LoadingSpinner />}

                        <InfiniteScroll
                            dataLength={issuesServerCount}
                            next={() => _fetchIssues(issuesTopics.length)}
                            hasMore={!everythingLoaded}
                            loader={<LoadingSpinner />}
                            scrollableTarget={'issue-group-issues-list'}
                        >
                            {!!issuesTopics &&
                                issuesTopics.map((issue, index) => (
                                    <IssueTopicItem issue={issue} isSelected={issue === selectedIssueTopic} handleClick={handleClick} key={index} />
                                ))}
                        </InfiniteScroll>
                        {!loading && issuesTopics.length === 0 && (
                            <div className="solutions-title-text" style={{ textAlign: 'center' }}>
                                {t('No item found')}
                            </div>
                        )}
                    </div>
                </div>
                <div className="solutions-group-overview-section y-overflow" id="solutions-group-scroll">
                    {selectedIssueTopic ? (
                        <IssueTopicOverview issueTopic={selectedIssueTopic} />
                    ) : (
                        <div className="solutions-title-text" style={{ textAlign: 'center', marginTop: 175 }}>
                            {loading ? null : t('No item found')}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
